import { createGlobalStyle } from 'styled-components';

export const colors = {
  primary: '#14DACC',     // Ana tema rengi (turkuaz)
  secondary: '#A1F7A0',   // İkincil tema rengi (açık yeşil)
  accent: '#14DACC',      // Vurgu rengi olarak ana rengi kullanıyoruz
  background: '#FFFFFF',  // Arka plan (istendiği üzere beyaz)
  darkBackground: '#F5F5F5', // Koyu arka plan (açık gri)
  text: '#333333',        // Metin rengi (koyu gri)
  lightText: '#666666',   // Açık metin rengi (orta gri)
  border: '#EEEEEE',      // Kenarlık rengi (açık gri)
  success: '#28a745',     // Başarı mesajları (yeşil)
  error: '#F43F5E',       // Hata mesajları (kırmızı)
  warning: '#FF934F',     // Uyarı mesajları (turuncu)
  blue: '#3B82F6',        // Mavi
};

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: 'Poppins', 'Roboto', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: ${colors.text};
    background-color: ${colors.background};
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', 'Roboto', sans-serif;
    font-weight: 600;
    color: ${colors.text};
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: 1rem;
    line-height: 1.7;
  }

  a {
    color: ${colors.primary};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${colors.secondary};
    }
  }

  button {
    cursor: pointer;
    font-family: 'Poppins', 'Roboto', sans-serif;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  section {
    padding: 4rem 0;

    @media (max-width: 768px) {
      padding: 2rem 0;
    }
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;

    @media (max-width: 768px) {
      padding: 0 1rem;
    }
  }
`;

export default GlobalStyle; 